









import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';

@Component
export default class ThreePanelConditionCategoryItemActionSubItem extends Vue {
  @Prop()
  selectedKeysIndex: any[];

  @Prop()
  item: any;

  @Prop()
  prefix: string;

  @Prop({default: true})  
  noEvents: boolean; 

  @Emit('toggle')
  onToggle(item: any) {}

  pSubItemsPicked: any[] = [];
  pSelectedKeysIndex: any = {};

  @Watch('selectedKeysIndex')
  onSelectedKeysIndexChaged(value: any) {
    this.pSelectedKeysIndex = value;
  }

  get isPicked() {
    return this.pSelectedKeysIndex[this.item.name];
  }

  data() {
    return {
      //pSubItemsPicked: this.subItemsPicked,
      pSelectedKeysIndex: this.selectedKeysIndex
    }
  }

  mounted() {
    if(!this.noEvents) {
      this.bus.on(this.prefix + '-selected-keys-index', this.onBusSelectedKeysIndex);
    }
  }

  beforeDestroy() {
    if(!this.noEvents) {
      this.bus.off(this.prefix + '-selected-keys-index', this.onBusSelectedKeysIndex);
    }
  }

  onBusSelectedKeysIndex(selectedKeysIndex: any) {
    this.pSelectedKeysIndex = selectedKeysIndex;
  }
}
